<template>
  <CalloutPanel
    :title="title"
    :description="description"
    :actions="actions"
    :compact="compact"
    :tint="type"
    :icon="bigIcon ? null : icon"
    :watermark-icon="bigIcon ? icon : null"
  >
    <slot />
  </CalloutPanel>
</template>

<script>
import CalloutPanel from '@ui/CalloutPanel.vue'

export default {
  name: 'AlertPanel',
  components: { CalloutPanel },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: 'info',
      validator: (val) => ['info', 'warning', 'danger', 'success'].includes(val)
    },
    actions: {
      type: Array,
      required: false,
      default: null
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    bigIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return ['fal', 'circle-check']
        case 'warning':
          return ['fal', 'exclamation-circle']
        case 'danger':
          return ['fal', 'exclamation-triangle']
        default:
          return ['fal', 'circle-info']
      }
    }
  }
}
</script>

<style scoped></style>
